import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getForecasts } from '@/store/slices/forecasterSlice';
import { Paper } from '@mui/material';
import { useEffect } from 'react';
import DataGrid from './DataGrid';

const ForecasterTable = () => {
  const dispatch = useAppDispatch();

  const { forecasts, forecastsRequestId, filters } = useAppSelector(state => state.forecaster);

  useEffect(() => {
    dispatch(getForecasts({}));
  }, [dispatch, filters]);

  return (
    <div className='w-full p-[20px]'>
      <Paper className='grid grid-cols-1 h-full'>
        <DataGrid data={forecasts} loading={!!forecastsRequestId} />
      </Paper>
    </div>
  );
};

export default ForecasterTable;
